export default __webpack_public_path__ + "assets/images/distributionGraph-47c95f3ed45167d00ae19b3cbf731da5.png";